import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastConfig = {
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
  theme: "light" as const,
};

const toastError = (err: unknown): void => {
  // Axios / HTTP error with a backend error code
  if (err && typeof err === "object" && "response" in err) {
    const axiosErr = err as { response?: { data?: { error?: string } } };
    const errorMsg = axiosErr.response?.data?.error;
    if (errorMsg) {
      const key = `backendErrors.${errorMsg}`;
      const msg = i18n.exists(key) ? i18n.t(key) : errorMsg;
      toast.error(msg, { ...toastConfig, toastId: errorMsg });
      return;
    }
  }

  // Plain string errors
  if (typeof err === "string") {
    toast.error(err, { ...toastConfig, toastId: err });
    return;
  }

  // Native Error object
  if (err instanceof Error) {
    toast.error(err.message, { ...toastConfig, toastId: err.message });
    return;
  }

  // Unknown / unexpected
  const fallback = i18n.exists("backendErrors.ERR_UNKNOWN")
    ? i18n.t("backendErrors.ERR_UNKNOWN")
    : "An error occurred";
  toast.error(fallback, { ...toastConfig, toastId: "ERR_UNKNOWN" });
};

export default toastError;
